import React, { useState } from "react";
import "./gallery.css";

const Gallery = () => {

  const initialImages = [];

  // ✅ photo65 skip karna
  for (let i = 1; i <= 99; i++) {
    if (i === 65) continue;   // 👈 ye best tarika hai
    initialImages.push(`${process.env.PUBLIC_URL}/images/photo${i}.jpg`);
  }

  const [images, setImages] = useState(initialImages);

  return (
    <div className="gallery-container">
      <h2 className="gallery-title">📸 Photo Gallery</h2>

      <div className="gallery-grid">
        {images.map((src, index) => (
          <div className="gallery-card" key={index}>
            <img
              src={src}
              alt={`Gallery Photo ${index + 1}`}
              className="gallery-img"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Gallery;